import * as React from 'react'
import { makeDefaultTooltipId } from '../../../../../utilities/helpers'
import { TooltipWithIcon } from '../../../../../components/TooltipWithIcon'
interface Props {
  className: string
  tooltipIconClassName?: string
  buttonLabel: string
  disabled?: boolean
  tooltipContent?: string | JSX.Element | JSX.Element[]
  tooltipProps?: any
  place?: string
  effect?: string
  onClick: () => void
}

export const ButtonWithTooltip = (props: Props) => {
  const {
    className,
    tooltipIconClassName,
    buttonLabel,
    place,
    effect,
    disabled,
    tooltipContent,
    onClick,
  } = props
  const tooltipId = makeDefaultTooltipId(buttonLabel)

  return (
    <span data-for={tooltipId} data-tip>
      <button className={className} onClick={onClick} disabled={disabled}>
        {buttonLabel}

        {tooltipContent && (
          <TooltipWithIcon
            tooltipIconClassName={tooltipIconClassName}
            tooltipId={tooltipId}
            tooltipContent={tooltipContent}
            place={place}
            effect={effect}
          />
        )}
      </button>
    </span>
  )
}
